import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { throwError } from 'rxjs';
import { isEmpty } from 'rxjs/operators';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class UtilsModule {
  
  constructor(private constants: ConstantsModule){}

  getWritableObject(obj: object): object{
    if(obj == null || obj == undefined) return obj;

    let objectConfig = {};
    for(let key in obj){
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  capitalize(word: string): string{
    if(!word) return '';
    word = word.toLowerCase();
    return word.replace(/^\w/, c => c.toUpperCase());
  }

  pascalCase(str:string):string {
    if(!str) return '';
    let res = str.split(' ');
    let res1 ='';
    for (let  i = 0; i < res.length; i++) {
      if(i == 0)
        res1 += this.capitalize(res[i]);
      else
        res1 += (" " + this.capitalize(res[i]));
    }
   return res1;
  }

  getComponentName(word: string): string {
    let components = {rainfall:'Rainfall',
    reservoir:'Reservoir',
    RiverAuthority:'River Authority',
    groundwater:'Ground Water',
    et:'Evapotranspiration',
    soilmoisture: 'Soil Moisture'
  }
    if(components[word]) return components[word];
    return word;
  }

  getTableSummaryIndex(tableData: any): number{
    if(!tableData)  return -1;
    let position = -1;

    let index = tableData.findIndex(item => item['name'].toUpperCase() === "TOTAL");
    if(index>= 0){
      position = index;
    }
    return position;
  }

  getDateObjectFromModelDate(date: string): Date{
    if(!date) return undefined;
    let year = parseInt(date.substr(0, 4), 10);
    let month = parseInt(date.substr(4,2), 10);
    let day = parseInt(date.substr(6,2), 10);

    return new Date(year, (isNaN(month)?0:(month-1)), (isNaN(day)?1:day));
  }

  getTodayAsModelDate(): string{
    let date = new Date();
    return this.getModelDateFromDate(date);
  }
  getDateandTimeString(timestamp, format) {
    var d = new Date(timestamp);
    var year = d.getFullYear().toString();
    var month: any = d.getMonth() + 1;
    month = month.toString();
    var date = d.getDate().toString();
    var hours = d.getHours().toString();
    var minutes = d.getMinutes().toString();
    var seconds = d.getSeconds().toString();
    if (month.length < 2) month = '0' + month;
    if (date.length < 2) date = '0' + date;
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;
    var str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
    switch (format) {
      case "DD-MM-YYYY HH:mm:ss":
        str = date + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
        break;
      case "YYYY-MM-DD hh:mm:ss":
        str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
        break;
      case "YYYY-MM-DD hh:mm":
        str = year + "-" + month + "-" + date + " " + hours + ":" + minutes;
        break;
      case "YYYY-MM-DD":
        str = year + "-" + month + "-" + date
        break;
      case "DD-MM-YYYY":
        str = date + "-" + month + "-" + year
        break;
      case "YYYYMMDD":
        str = year.toString() + month.toString() + date.toString()
        break;
      case "YYYYMM":
        str = year.toString() + month.toString()
        break;
      case "YYYY":
        str = year.toString()
        break;
    }

    return str;
  }

  getModelDateFromDate(date: Date): string{
    let year = (date.getFullYear()).toString();
    let month = (((date.getMonth()+1)<10)?"0"+(date.getMonth()+1):date.getMonth()+1).toString();
    let day = ((date.getDate() < 10)?"0"+date.getDate():date.getDate()).toString();
    return year+month+day;
  }

 

  replaceStringAt(original: string, index: number, replacement: string): string{
    return original.substr(0, index) + replacement+ original.substr(index + replacement.length);
  }

  validDateFormat(format: string): boolean{
    return (format && format.toLowerCase().indexOf("season") < 0);
  }

  validDateFormatGw(format: string): boolean{
    return (format && format.toLowerCase().indexOf("-") < 0);
  }

  /**
   * Logic :
   * prepare the values in all possible formats i.e MMM, mm dd etc
   * use these values to replace the format keys in the original format string
   * @param date 
   * @param format 
   */
  getDateInFormatFromModelDate(date: string, format: string): string{
    if(!date) return date;
    
    let year = parseInt(date.substr(0, 4), 10);
    let month = parseInt(date.substr(4,2), 10);
    let day = parseInt(date.substr(6,2), 10);
    
    try{
      return this.getDateInFormat(year, month, day, format);
    }catch(e){
      throw e;
    }
  }

  getDateInFormat(year: number, month: number, day: number, format: string): string{
    if(!this.validDateFormat(format))
      throw "Invalid date format";
    
    let monthFormat = {
      MMM : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
    let result = format;
    /**
     * this object will be used to replace the values in the key in the required format
     */
    let formattedDateObject = {
      MMM : (format.indexOf('MMM') >= 0)?monthFormat['MMM'][month-1]:'',
      mmm : (format.indexOf('mmm') >= 0)?monthFormat['MMM'][month-1]:'',
      MM : (format.indexOf('MM') >= 0)?(month < 10)?("0"+month):month:'',
      mm : (format.indexOf('mm') >= 0)?(month < 10)?("0"+month):month:'',
      yyyy : (format.indexOf('yyyy') >= 0)?year:'',
      YYYY : (format.indexOf('YYYY') >= 0)?year:'',
      yy : (format.indexOf('yy') >= 0)?year.toString().substr(2,2):'',
      YY : (format.indexOf('YY') >= 0)?year.toString().substr(2,2):'',
      dd : (format.indexOf('dd') >= 0)?(day < 10)?("0"+day):day:'',
      DD : (format.indexOf('DD') >= 0)?(day < 10)?("0"+day):day:''
    }

    for(let key in formattedDateObject){
      if(result.indexOf(key) >= 0){
        /**
         * If the model date doesn't match the required format, then try to fill whatever we can and
         * eliminate the other parameters.
         */
        if(!formattedDateObject[key]){
          result = result.replace(key, '');
          continue;
        }
        result = this.replaceStringAt(result, result.indexOf(key), formattedDateObject[key].toString())
      }
    }
    
    //remove the preceeding and trailing -
    result = result.replace('--', '-').replace(/^-/,'').replace(/-$/,'');
    return result;
  }

  getDateInFormatFromDateObject(date: Date, format: string): string{
    if(!date) return '';
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let day = (date.getDate() == 0)?0:date.getDate();
    
    return this.getDateInFormat(year, month, day, format);;
  }

  /**
   * Convert list of model dates into the required format
   * @param dateList 
   * @param format 
   */
  convertListOfModelDateToFormat(dateList: Array<String>, format: string): Array<String>{
    if(!dateList) return dateList;
    let result = [];

    for(let index=0; index < dateList.length; index++){
      try{
        result.push(this.getDateInFormatFromModelDate(dateList[index].toString(), format));
      }catch(e){
        console.log(e);
        throw e;
      }
    }

    return result;
  }

  getaggregationtypedisplay(Aggtype){
    if(Aggtype === "SUM")
      return "Cumulative";
    else if(Aggtype === "AVG")
     return "Average";
    else if(Aggtype === "MIN")
     return "Minimum";
    else if(Aggtype === "MAX")
     return "Maximum"; 

  }

  getmonthyearforyearType(enddate):string{
    var date = new Date();
    if(enddate == date.getFullYear()){
      let month = ((date.getMonth()+1) < 10 ? '0' + (date.getMonth()+1) : '' + (date.getMonth()+1));
      let curdate = (date.getDate() < 10 ? '0' + date.getDate(): '' + date.getDate());
      return (month +""+curdate);
    }else{
      return "1231";
    }
    
  }

  getLastDayForGivenModelDate(date: string): string{
    if(!date) return date;
    else if(date.length == 4) return date + this.getmonthyearforyearType(date);
    else if(date.length == 6){
      let currentDate = new Date();
      let year = Number.parseInt(date.substr(0,4));
      let month = Number.parseInt(date.substr(4,2));
      let lastDate = new Date(year, month, 0);
      if(year == currentDate.getFullYear() && month == currentDate.getMonth()+1)
        date = date + (currentDate.getDate() < 10 ? '0' + currentDate.getDate(): '' + currentDate.getDate());
      else
        date = date + ((lastDate.getDate() < 10)?"0"+lastDate.getDate():lastDate.getDate());
}   
    return date;
  }

  getRandomColor(opacity: number): string{
    let r = (Math.floor(Math.random() * 255) + 0).toString(),
        g = (Math.floor(Math.random() * 255) + 0).toString(),
        b = (Math.floor(Math.random() * 255) + 0).toString();

    return "rgba("+r+","+g+","+b+","+opacity+")";
  }

  isChartDataEmpty(data: object): boolean{
    if(!data || !data['data'] || data['data'].length == 0 || !data['data'][0] || !data['data'][0]['data'] ||data['data'][0]['data'].length==0)  return true;
    return false;
  }
  
  isTableDataEmpty(data: object): boolean{
    if(!data || !data['dataSource'] || data['dataSource'].length == 0 || Object.keys(data['dataSource']).length == 0) return true;
    return false;
  }

  addNDaysToDateObject(dateObj: Date, numOfDays: number): Date{
    if(!dateObj)  return null;
    return new Date(dateObj.setTime( dateObj.getTime() + numOfDays * 86400000 ));
  }

  downloadFile(data: any, filename: string) {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // let EXCEL_TYPE2 = "application/vnd.ms-excel"
    if(!data) return;
    let blob = new Blob([data], {type: EXCEL_TYPE});
    let objectUrl = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    a.target = '_blank';
    a.click();
  }

  addEachPermanentParamsToURL(params: Object, options: Object): any {
    params = this.getWritableObject(params);
    Object.assign(params, {
      "locname": options['locname']
      , "locuuid": options['locuuid']
      , "loctype": options['loctype']
      , "view": options['view']
      , "component": options['component']
    });

    return params;
  }

  getStartOfMonsoon(yearBack: number): Date{
    let currDate = new Date();
    currDate.setDate(currDate.getDate() - 365 * yearBack);

    let monsoonYear = currDate.getFullYear();
    if((currDate.getMonth()+1) < 6)
      monsoonYear -= 1;

    return new Date(monsoonYear, 5, 1);
  }

  getNoOfMonths(sDate:Date, eDate: Date)
  {
      let noOfMonths = (eDate.getFullYear() - sDate.getFullYear())*12;
      noOfMonths-=sDate.getMonth();
      noOfMonths+=eDate.getMonth()+1;
      return noOfMonths <= 0 ? 0 : noOfMonths;
  }

  getDateDiff(date1str:string,date2str:string){
    let date1 = new Date(date1str);
    let date2 = new Date(date2str);
    let diffTime = Math.abs(date2.getTime() - date1.getTime());
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays;
  }

  fixedEncodeURIComponent(str) : string{
      return encodeURI(str).replace(/\(/g, "%28").replace(/\)/g, "%29");
  }

  getTSForModelDate(date: string): number{
    if(date == undefined || date.length < 8) return 0;

    let dateObj = new Date(Number.parseInt(date.substring(0,4)), Number.parseInt(date.substring(4,6))-1, Number.parseInt(date.substring(6,8)));
    return dateObj.getTime();
  }
 
  isEmpty(data : any):boolean{
    return data?true:false;
  }
 
  getPrecisedValue(value: any, unit:any)
  {
    if(value&&typeof(value) == 'number')
    {
      if(unit&&unit=='mm')
        value = value.toFixed(0);
      else if(unit&&(unit=='m'||unit=='cm'))
        value = Number.isInteger(value)? value:value.toFixed(3);
    }
    return value;
  }
  checkfield(field):boolean{
    if(field === null || field === '' || field === undefined || Object.keys(field).length == 0)
      return false;
    else 
      return true;  
  }
  checkfields(field):boolean{
    if(field === null || field === '' || field === undefined)
      return false;
    else 
      return true;  
  }
  checkarrayfield(field):boolean{
    let flag = false;
    if(field){
      if(field.length > 0){
        flag = true;
      }
    }
    return flag;
  }
  getModelDateWithDateFormat(date: Date, format: string): string{
    if(!date) return '';
    
    let result = '';
    if(format == this.constants.DATEPICKER_DATE_FORMAT.YEAR)
      result = this.getModelDateFromDate(date).substr(0,4);
    else if(format == this.constants.DATEPICKER_DATE_FORMAT.MONTH)
      result = this.getModelDateFromDate(date).substr(0,6);
    else
      result = this.getModelDateFromDate(date);
    
    return result;
  }
}
